module.exports = __webpack_public_path__ + "static/media/edit.e0595af0.svg";